import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import { Tabs, Tab, Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

const ScrollableTabsButtonPrevent = ({
  classes,
  defaultActive,
  tabs,
  divider,
  dividerProps,
  sectionProps,
  isFixed,
  ...props
}) => {
  const [activeTab, setActiveTab] = React.useState(defaultActive);
  const onChange = React.useCallback((event, newValue) => setActiveTab(newValue), [setActiveTab]);
  const selectedTab = props.value || activeTab;

  return (
    <Fragment>
      <AppBar
        position="static"
        color="default"
        classes={{ root: isFixed ? classes.appBarRootFixed : classes.appBarRoot }}
      >
        <Tabs
          value={selectedTab}
          onChange={props.onChange ? props.onChange : onChange}
          variant="scrollable"
          scrollButtons="off"
          classes={{ indicator: classes.indicator, scroller: classes.scroller }}
          {...props}
        >
          {tabs.map((tab) => (
            <Tab
              label={tab.label}
              aria-label={tab.label}
              data-testid={tab.label}
              key={tab.label}
              disabled={tab.disabled}
              classes={{ root: classes.tabRoot }}
            />
          ))}
        </Tabs>
        {divider && <Divider classes={{ root: classes.divider }} {...dividerProps} />}
        {tabs.map(
          (tab, index) =>
            !tab.route && (
              <Box key={tab.label} hidden={index !== selectedTab} {...sectionProps}>
                {tab.content}
              </Box>
            ),
        )}
      </AppBar>
    </Fragment>
  );
};

ScrollableTabsButtonPrevent.propTypes = {
  classes: PropTypes.shape({}),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
      content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      disabled: PropTypes.bool,
    }),
  ),
  defaultActive: PropTypes.number,
  divider: PropTypes.bool,
  isFixed: PropTypes.bool,
  dividerProps: PropTypes.shape({}),
};

ScrollableTabsButtonPrevent.defaultProps = {
  classes: {},
  tabs: [],
  divider: false,
  isFixed: false,
  defaultActive: 0,
  dividerProps: {},
};

export default ScrollableTabsButtonPrevent;
